import {
  LOADING_RIESGOS,
  LOAD_RIESGOS,
  ERROR_RIESGOS,
  LOADING_COMPROMISOS,
  LOAD_COMPROMISOS,
  ERROR_COMPROMISOS,
  LOADING_NOVEDADES,
  LOAD_NOVEDADES,
  ERROR_NOVEDADES,
  LOADING_APRENDIZAJES,
  LOAD_APRENDIZAJES,
  ERROR_APRENDIZAJES,
  LOADING_RETROSPECTIVAS,
  LOAD_RETROSPECTIVAS,
  ERROR_RETROSPECTIVAS,
} from "./briefcaseArtifactsTypes";

// Estado de las 5 matrices de artefactos, cada una con su sub-slice {items, loading, error}.
const emptySlice = { items: [], loading: true, error: false };

const initial = {
  riesgos: { ...emptySlice },
  compromisos: { ...emptySlice },
  novedades: { ...emptySlice },
  aprendizajes: { ...emptySlice },
  retrospectivas: { ...emptySlice },
};

const setLoading = (state, key) => ({
  ...state,
  [key]: { items: [], loading: true, error: false },
});
const setLoaded = (state, key, payload) => ({
  ...state,
  [key]: { items: payload || [], loading: false, error: false },
});
const setError = (state, key) => ({
  ...state,
  [key]: { items: [], loading: false, error: true },
});

const briefcaseArtifactsReducer = (state = initial, action) => {
  switch (action.type) {
    case LOADING_RIESGOS:
      return setLoading(state, "riesgos");
    case LOAD_RIESGOS:
      return setLoaded(state, "riesgos", action.payload);
    case ERROR_RIESGOS:
      return setError(state, "riesgos");

    case LOADING_COMPROMISOS:
      return setLoading(state, "compromisos");
    case LOAD_COMPROMISOS:
      return setLoaded(state, "compromisos", action.payload);
    case ERROR_COMPROMISOS:
      return setError(state, "compromisos");

    case LOADING_NOVEDADES:
      return setLoading(state, "novedades");
    case LOAD_NOVEDADES:
      return setLoaded(state, "novedades", action.payload);
    case ERROR_NOVEDADES:
      return setError(state, "novedades");

    case LOADING_APRENDIZAJES:
      return setLoading(state, "aprendizajes");
    case LOAD_APRENDIZAJES:
      return setLoaded(state, "aprendizajes", action.payload);
    case ERROR_APRENDIZAJES:
      return setError(state, "aprendizajes");

    case LOADING_RETROSPECTIVAS:
      return setLoading(state, "retrospectivas");
    case LOAD_RETROSPECTIVAS:
      return setLoaded(state, "retrospectivas", action.payload);
    case ERROR_RETROSPECTIVAS:
      return setError(state, "retrospectivas");

    default:
      return state;
  }
};

export default briefcaseArtifactsReducer;
